module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_7.71f914c6.png";